




import { mapGetters } from 'vuex';

export default {
	name: 'JobFilters',

	setup() {
		const options = reactive([
			{ text: 'Remote', value: 'Remote' },
			{ text: 'In Person', value: 'InPerson' },
			{ text: 'Hybrid', value: 'Hybrid' },
		]);

		const filter = reactive({
			filterBy: 'LocationType',
			filterValue: null,
		});

		return { filter, options };
	},

	computed: {
		...mapGetters('jobs', {
			currentFilters: 'getFilters',
		}),

		otherFilters() {
			return this.currentFilters?.filters.filter((object) => object.filterBy !== 'LocationType') || null;
		},
		locationFilter() {
			return this.currentFilters?.filters.filter((object) => object.filterBy === 'LocationType') || null;
		},
	},

	watch: {
		'filter.filterValue'() {
			this.setFilter();
		},
		locationFilter() {
			if (!this.locationFilter) {
				this.filter.filterValue = null;
			}
		},
	},

	methods: {
		async setFilter() {
			let filters = [];
			if (this.filter.filterValue) {
				filters.push(JSON.parse(JSON.stringify(this.filter)));
			}
			if (this.otherFilters) {
				filters.push(...this.otherFilters);
			}

			await this.$store.dispatch('jobs/setFilters', {
				filters,
			});

			await this.$store.dispatch('jobs/getFilteredCompanyJobs');
		},
	},
};
